<script setup>
defineProps({ account: { type: Object, required: true } });
const emit = defineEmits(['page']);
function rate(value) {
  let number = Number(value);
  if (!Number.isFinite(number) || number < 0) number = 0;
  const units = ['S/s', 'KS/s', 'MS/s', 'GS/s', 'TS/s'];
  let unit = 0;
  while (number >= 1000 && unit < units.length - 1) { number /= 1000; unit++; }
  return `${number.toFixed(2)} ${units[unit]}`;
}
</script>

<template>
  <v-row dense class="mb-4">
    <v-col cols="12" sm="4"><v-card variant="outlined" class="pa-4"><div class="text-caption">{{ $t('current_hashrate') }}</div><div class="text-h6">{{ rate(account.currentHashrate) }}</div></v-card></v-col>
    <v-col cols="12" sm="4"><v-card variant="outlined" class="pa-4"><div class="text-caption">{{ $t('average_hashrate') }}</div><div class="text-h6">{{ rate(account.averageHashrate) }}</div></v-card></v-col>
    <v-col cols="12" sm="4"><v-card variant="outlined" class="pa-4"><div class="text-caption">{{ $t('workers') }}</div><div class="text-h6">{{ account.workerOnline || 0 }} / {{ account.workerTotal || 0 }}</div></v-card></v-col>
  </v-row>
  <v-table class="border rounded" density="comfortable">
    <thead><tr><th>{{ $t('worker') }}</th><th>{{ $t('current_hashrate') }}</th><th>{{ $t('average_hashrate') }}</th><th>{{ $t('status') }}</th><th>{{ $t('last_shares') }}</th></tr></thead>
    <tbody>
      <tr v-for="(worker, index) in account.workers" :key="index">
        <td class="text-monospace">{{ worker.name }}</td><td>{{ rate(worker.currentHashrate) }}</td><td>{{ rate(worker.averageHashrate) }}</td>
        <td>{{ $t(worker.offline ? 'offline' : 'online') }}</td><td>{{ worker.lastShares ? $filters.time(worker.lastShares) : '—' }}</td>
      </tr>
      <tr v-if="!account.workers?.length"><td colspan="5" class="text-center py-6">{{ $t('no_data') }}</td></tr>
    </tbody>
  </v-table>
  <v-pagination v-if="account.workerTotal > 15" :length="Math.ceil(account.workerTotal / 15)" :total-visible="5" @update:model-value="emit('page', $event)" />
</template>
